import React, { useEffect, useState } from "react";
import Button from "../modules/Button";
// import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { GetBaseUrl } from "../modules/getBaseUrl";
import { useDispatch, useSelector } from "react-redux";
import "./submit.scss";
import tick2 from "../../Assets/svg/tick wave.svg";
import tick from "../../Assets/svg/green-tick-filled.svg";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import FooterText from "../modules/FooterText";
import RedirectHelp from "../modules/RedirectHelp";
import WaitListScreen from "../ApplicationPreview/WaitListScreen";
import { api } from "../../Services";
import { addTokenInfo, doLogout } from "../LoginPage/redux/actions";
import ModalComponent from "../modules/Modal";
import RatingSize from "../modules/Stars";
import Input from "../modules/Input";
import GradientLoader from "../modules/Loader";
import AwardedScreen from "../AwardedScreen";
import { useNavigate } from "react-router-dom";
import { resetState } from "../PersonalInfo/redux/actions";
import { resetIncome } from "../IncomeDetails/redux/actions";
import { resetEdu } from "../Education/redux/actions";
import { resetRegister } from "../Register/redux/actions";
import { resetApp } from "../ApplicationForm/redux/actions";
import { resetQueries } from "../Queries/redux/actions";
import { resetStatus } from "../WelcomeBack/redux/actions";
import { clearDisburse } from "../DisburseForm/redux/actions";
import { resetClear } from "../Connect/redux/actions";

const stages = ["Application", "Verification", "Result"];

function SubmittedWelcome(props) {
  const navigate = useNavigate();

  // const [updateDropout, setUpdateDropout] = useState(false);
  const [percentage, setPercentage] = useState(66);
  const [phase, setPhase] = useState("Submitted");
  const personalInfo = useSelector((state) => state.personal.personalInfo);
  const idInfo = useSelector((state) => state.tokens.tokens);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const dispatch = useDispatch();
  const [dropType, setDropType] = useState("update");
  const [transaction, setTransaction] = useState({
    num: "",
    amount: "",
    date: "",
  });
  const incomeInfo = useSelector((state) => state.income.incomeInfo);
  const [modalTitle, setModalTitle] = useState("Complete Dropout Request");
  const [btnList, setBtnList] = useState([
    { title: "Design", selected: false },
    { title: "Convenience", selected: false },
    { title: "Process", selected: false },
    { title: "Flexibility", selected: false },
    { title: "Ease of Use", selected: false },
    { title: "Other", selected: false },
  ]);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(true);
  const [alertType, setAlertType] = useState({ msg: "", type: "" });
  const education = useSelector((state) => state.education.eduInfo);

  const [feedback, setFeedback] = useState({
    stars: 0,
    options: [],
    comment: "",
  });
  const [ModalData, setModalData] = useState({
    show: false,
    type: "cancel",
    title: "So...How was it?",
    countDown: " ",
    desc: "We would love to know more about your experience regarding the application process :)",
  });
  // const [P, setP] = useState();
  const setSelect = (index) => {
    let list = { ...feedback };
    list["options"] = [...list["options"], btnList[index].title];
    setFeedback({ ...list });
  };
  const showStatus = (status) => {
    if (status === "Application") {
      status = (
        <div className="with-icon">
          <img src={tick} alt="tick" />
          {status}
        </div>
      );
    }
    return status;
  };
  const openStatus = () => {
    let url = GetBaseUrl(window.location.href);
    // window.location.replace(url + "/application/app-preview/verification");
    navigate("/application/app-preview/verification");
  };
  const showImpact = async () => {
    // console.log("in checkModified after timer");
    try {
      const impact = await api.showImpact(tokenData.appId, tokenData.token);
      console.log("users", impact);
      if (impact.statusCode == 200) {
        dispatch(addTokenInfo(["showImpact", impact?.data]));
      }
      // destructureData(users.data);
      // dispatch(modifyPage('no'));
    } catch (error) {
      console.error("Error invoking Aadhaar OTP:", error);
      // Handle error scenario
    }
    // setModified(false);
    // }
  };
  const sendFed = async () => {
    try {
      setLoading(true);
      let data = {
        feedbackPertainsTo: [...feedback.options],
        rate: feedback.stars,
        comment: feedback.comment,
        parentApplicationId: idInfo.appId,
      };

      const send = await api.feedback(data, idInfo.token);
      console.log("query", send);
      return send;
    } catch (err) {}
  };
  const fedSubmit = async () => {
    try {
      let result = await sendFed();
      if (result.statusCode == 200) {
        setLoading(false);
        dispatch(addTokenInfo(["showFeedback", false]));
        showFeedback();
        setModalData({ ...ModalData, show: false });
        setAlert(true);
        // notify("Feedback submitted successfully.");

        setTimeout(() => setAlert(false), 3000);
      }
    } catch (err) {
      setLoading(false);
      // notify("Sorry! Something went wrong,Please try again.");
      // alert('Sorry! Something went wrong,Please try again.');
    }
  };
  const feedbackContent = () => {
    if (ModalData.desc !== "") {
      setModalData({
        ...ModalData,
        desc: "",
      });
    }

    return (
      <div className="feedback-content">
        <div className="stars sub-option-text">
          How was your overall experience?
          <RatingSize
            value={feedback.stars}
            onChange={(e) => setFeedbackData("stars", e)}
          />
        </div>
        {feedback.stars > 0 && (
          <div className="multi-btns">
            <div className="sub-option-text">
              What does this feedback pertain to?
              <div className="buttons-set">
                {btnList.map((item, index) => (
                  <div
                    onClick={() => setSelect(index)}
                    className={` sub-option-text ${
                      feedback.options.includes(item?.title)
                        ? "contained"
                        : "btn-option"
                    }`}
                  >
                    {item?.title}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        {feedback.options?.length > 0 && (
          <div className="comment-field">
            <Input
              onChange={(e) =>
                setFeedbackData("comment", e.replace(/[!@#$%^&*<>":}{'']/g, ""))
              }
              placeholder={"Could you tell us a little more?"}
            />
          </div>
        )}
        <div className="cred-btn">
          <Button
            onClickHandler={() => fedSubmit()}
            // disabled={
            //   type === "mobile"
            //     ? mobile.number.length !== 10
            //     : mobile.otp === "000000" || mobile.otp.length !== 6
            // }
            disabled={feedback?.options?.length === 0}
            // value={type === "mobile" ? "Send OTP" : "Sign in"}
            value={"Submit"}
            type={"contained"}
          />
          <Button
            onClickHandler={() => setModalData({ ...ModalData, show: false })}
            value={"I’ll do this later"}
            type={"only-text"}
          />
        </div>
      </div>
    );
  };
  const showFeedback = async () => {
    // console.log("in checkModified after timer");
    try {
      const fedResult = await api.checkFeedback(
        tokenData.appId,
        tokenData.token
      );
      console.log("fedResult", fedResult);
      if (fedResult.statusCode == 200) {
        if (fedResult?.data === null) {
          dispatch(addTokenInfo(["showFeedback", true]));
        }
      }
      // destructureData(users.data);
      // dispatch(modifyPage('no'));
    } catch (error) {
      console.error("Error invoking Aadhaar OTP:", error);
      // Handle error scenario
    }
    // setModified(false);
    // }
  };
  const getImpact = () => {
    let url = GetBaseUrl(window.location.href);
    // window.location.replace(url + "/application/impact");
    navigate("/application/impact");
  };
  const setTransactionData = (type, e) => {
    let trans = transaction;
    trans[type] = e;
    setTransaction({ ...trans });
  };

  const setFeedbackData = (type, e) => {
    let fed = feedback;
    fed[type] = e;
    setFeedback({ ...fed });
  };
  const setCollect = () => {
    // console.log("info in set", info);
    return (
      <div className="field-set">
        <div className="md-desc">
          Please provide us with the Refund Transaction details so we verify and
          complete your dropout request
        </div>
        <div className="field-one field">
          <Input
            placeholder={"Scholarship amount UTR/Transaction number"}
            onChange={(e) =>
              setTransactionData("num", e.match(/[a-zA-Z0-9]+/g)?.join(""))
            }
            value={transaction.num}
          />
        </div>
        <div className="field-two field">
          <Input
            value={transaction.amount}
            inputType={"rupee"}
            onChange={(e) =>
              setTransactionData("amount", e.match(/\d+/g)?.join(""))
            }
            placeholder={"Enter Amount"}
          />
        </div>
        <div className="field-three field">
          <Input
            type="date"
            placeholder={"Transaction Date"}
            onChange={(e) => setTransactionData("date", e)}
            value={transaction.date}
          />
        </div>
      </div>
    );
  };
  const setConfirm = () => {
    return (
      <div className={`confirm-text `}>
        <div className="confirm-text-div">
          <img className="sad" src={tick2} alt="happy" />
        </div>
        <div className={`md-title`}>Dropout Request Submitted!</div>
        <div className=" md-desc">
          <div>
            An IDFC FIRST Bank representative will confirm the transaction
            details provided by you and complete your request
          </div>
          <div>
            You will receive confirmation of your dropout status on your email{" "}
            <span>{personalInfo?.email}</span>
          </div>
          <div>Sorry to see you go :(</div>
        </div>
      </div>
    );
  };

  const cancelSession = () => {
    setModalData({ ...ModalData, show: false, type: "" });
    setTransaction({ num: "", amount: "", date: "" });
  };
  const dropoutCall = async (data) => {
    try {
      const users = await api.dropout(data, tokenData.token);
      if (users.statusCode !== 200 && users.data.includes("Session expired")) {
        logoutMsg();
      }
      if (users.statusCode == 200) {
        dispatch(addTokenInfo(["isDropout", false]));
        dispatch(addTokenInfo(["showDropout", false]));
      }
      return users;
    } catch (error) {
      console.error("Error invoking Aadhaar OTP:", error);
      if (error?.data?.includes("Session expired")) {
        logoutMsg();
      }
      setAlertType({
        msg: "Sorry! Something went wrong, Please connect with administrater",
        type: "otp",
      });

      return error;
      // Handle error scenario
    }
  };
  const CombineData = () => {
    let data = { userId: idInfo?.userId };
    // console.log("in combine", personalInfo);
    let personalInfo2 = { ...personalInfo, addressProof: "" };
    let eduInfo2 = { ...education, admissionLetter: "", paymentReciept: "" };
    let prevData = tokenData?.totalLoginResponse?.user?.DropoutInfo;
    if (prevData) {
      prevData.scholarshipAmountRefundUTR = transaction?.num;
      prevData.scholarshipAmountRefunded = transaction?.amount;
      prevData.transactionDate = transaction?.date;
    }
    function filterAndRemove(obj) {
      for (let i in obj.membersList) {
        obj.membersList[i].doc = "";
        // obj.membersList[i].lastName = "";
      }

      return obj;
    }
    let incomeInfo2 = { ...filterAndRemove(incomeInfo) };
    data = {
      ...data,
      application: {
        id: idInfo?.appId,
        applicationStatus: idInfo?.applicationStatus,
      },
    };

    data = {
      ...data,
      application: { ...data.application, personalInfo: { ...personalInfo2 } },
    };
    data = {
      ...data,
      application: {
        ...data?.application,
        incomeInfo: { ...incomeInfo2 },
      },
    };
    data = {
      ...data,
      application: {
        ...data?.application,
        eduInfo: { ...eduInfo2 },
        salesForceApplicationId:
          tokenData?.applicationData?.salesForceApplicationId,
        salesforceStudentAppNumber:
          tokenData?.applicationData?.salesforceStudentAppNumber,
      },
      DropoutInfo: { ...prevData },
      registration: { ...tokenData?.registrationData },
      salesForceUserId: tokenData?.salesForceUserId,
    };

    return data;
  };

  const submitDropdown = async () => {
    setModalTitle("");
    try {
      let call = await dropoutCall(CombineData());
      if (call.statusCode == 200) {
        setModalData({
          ...ModalData,
          show: true,
          title: "",
          desc: setConfirm(),
          type: "clear",
        });
      }
    } catch (err) {
      setAlertType({
        msg: "Sorry! Something went wrong, Please connect with administrater",
        type: "otp",
      });
    }
  };

  const getLogout = async () => {
    // const personalInfo = useSelector((state) => state.personal.personalInfo);
    // const dispatch = useDispatch();
    // const tokenData = useSelector((state) => state.tokens.tokens);

    try {
      let users = await api.logout(tokenData.token, personalInfo?.mobile);
      console.log("logout api", users);
      // if (users.statusCode == 200) {
      dispatch(resetState());
      dispatch(resetIncome());
      dispatch(resetEdu());
      dispatch(resetRegister());
      dispatch(resetApp());
      dispatch(resetQueries());
      dispatch(resetStatus());
      dispatch(clearDisburse());
      dispatch(resetClear());
      dispatch(doLogout());
      // }
      // return users;
    } catch (error) {
      console.error("Error logging out:", error);

      //   } finally {
      // setIsLoading(false);
    }
  };
  const logoutMsg = async () => {
    let users = await getLogout();
    console.log("logout api", users);
    console.log("u have been logged out");
  };
  const callDocs = async () => {
    try {
      const docs1 = await api.getDocuments(
        "application",
        tokenData.appId,
        tokenData.token
      );
      if (docs1.statusCode !== 200 && docs1.data.includes("Session expired")) {
        logoutMsg();
      }
      console.log(JSON.stringify(docs1));
      dispatch(addTokenInfo(["docs", docs1.data]));
    } catch (err) {
      console.log("err", err.data);
      if (err?.data?.includes("Session expired")) {
        logoutMsg();
      }
    }
  };

  useEffect(() => {
    // tokenData.applicationStatus
    setTimeout(() => callDocs(), 200);

    showFeedback();
    showImpact();
    setPhase(tokenData?.applicationStatus);
    // setPhase("Awarded");

    if (
      tokenData.totalLoginResponse?.user?.DropoutInfo?.dropOut &&
      tokenData.totalLoginResponse?.user?.DropoutInfo?.dropoutStatus ===
        "Rejected" &&
      (tokenData.totalLoginResponse?.user?.DropoutInfo
        ?.scholarshipAmountRefundUTR === "" ||
        tokenData.totalLoginResponse?.user?.DropoutInfo
          ?.scholarshipAmountRefunded === "" ||
        tokenData.totalLoginResponse?.user?.DropoutInfo?.transactionDate === "")
    ) {
      dispatch(addTokenInfo(["isDropout", true]));

      // setUpdateDropout(true);
    } else {
      dispatch(addTokenInfo(["isDropout", false]));
    }
  }, []);
  useEffect(() => {
    if (tokenData.showFeedback) {
      setTimeout(() => setModalData({ ...ModalData, show: true }), 3000);
    }
  }, [tokenData.showFeedback]);
  useEffect(() => {
    console.log("impact");
  }, [tokenData.showImpact]);

  useEffect(() => {
    setModalData({
      ...ModalData,
      desc: setCollect(),
    });
  }, [transaction]);

  useEffect(() => {
    if (tokenData.isDropout && tokenData.showDropout)
      setModalData({
        ...ModalData,
        show: true,
        desc: setCollect(),
        type: "collect",
      });
  }, [tokenData.showDropout]);
  console.log("personalInfo", tokenData);
  return (
    <div className="form-div welcome-page submitted-welcome">
      {tokenData.isDropout && (
        <div className={`update-option drop-update  update md-desc`}>
          <div
            className={`update-left   ${
              dropType === "updated" && "set-title"
            }"set-title"`}
          >
            <img src={alert} alt="alert" />
            {/* Update Transaction details to Complete Dropout Request */}
            Dear {personalInfo.firstName}, Your dropout request has been
            rejected as the refund of scholarship fee is pending. Kindly update
            the transaction details to complete dropout request.
            {/* {dropType === "update" */}
            {/* ? "Update Transaction details to Complete Dropout Request" */}
            {/* : "Your Dropout Request In Process"} */}
          </div>
          {dropType === "update" && (
            <Button
              onClickHandler={() =>
                setModalData({
                  ...ModalData,
                  show: true,
                  desc: setCollect(),
                  type: "collect",
                })
              }
              type={"contained"}
              value={"Update Details"}
            />
          )}
        </div>
      )}
      {tokenData.showImpact && (
        <div className={`update-option  impact md-desc`}>
          <div className={`update-left   `}>
            <div className="left-top md-title">Impact Survey</div>
            <div className="left-btm md-desc">
              We would love to know more about your experience with the
              Scholarship program. Please take out a couple of minutes to let us
              know :)
            </div>
          </div>
          <Button
            onClickHandler={() => getImpact()}
            type={"contained"}
            value={"View Assessment Form"}
          />
          {/* {dropType === "update" && (
            
          )} */}
        </div>
      )}
      {phase === "Awarded" ? (
        <>
          <AwardedScreen name={personalInfo?.firstName} />
        </>
      ) : phase === "Waitlisted" ? (
        <>
          <WaitListScreen />
        </>
      ) : (
        <>
          <div className="form-title">
            Welcome back, {personalInfo.firstName}!
          </div>{" "}
          <div className="content set-title content-item">
            {/* <div className="content-left "> */}
            <div className="item-top">Continue your Application</div>
            <div className="item-id">
              Application ID:{" "}
              <span>{idInfo.applicationData.salesforceStudentAppNumber}</span>
            </div>
          </div>
          <div className="status-box">
            <div className="md-desc">Current Status</div>
            <div className="status-box-div">
              <div className={`bc  ${phase}`}>
                {stages.map((item, index) => (
                  <div className={`status-section ${item}`}>
                    <div
                      className={` set-title status-item ${
                        index + 1 === stages?.length && "last-stage"
                      }`}
                    >
                      {showStatus(item)}
                    </div>
                    {index + 1 !== stages?.length && (
                      <div className="status-icon">
                        <NavigateNextIcon fontSize="small" />
                      </div>
                    )}
                  </div>
                ))}
              </div>
              {/* <div className="md-desc">Rejected/Incorrect</div> */}
              {(phase === "Document_Verification" ||
                phase === "RCU_Verification" ||
                phase === "Shortlisted") && (
                <Button
                  type={"outlined-grey"}
                  onClickHandler={() => openStatus()}
                  value={"View Details"}
                />
              )}

              {/* <div className="view-btn">View Details</div> */}
            </div>
            <RedirectHelp />
          </div>
        </>
      )}
      <FooterText />
      {ModalData.show && (
        <ModalComponent
          show={ModalData.show}
          handleClose={() => setModalData({ ...ModalData, show: false })}
          title={`${tokenData.isDropout ? modalTitle : "So...How was it?"}`}
          content={ModalData.desc}
          className={`${
            tokenData.isDropout ? "transaction-model" : "feedback"
          }`}
          // countDown={ModalData.countDown}
        >
          {tokenData.isDropout ? (
            <div className="modal-btn-set">
              {ModalData.type !== "clear" && (
                <Button
                  disabled={
                    transaction.amount === "" ||
                    transaction.num === "" ||
                    transaction.date === ""
                  }
                  onClickHandler={() => submitDropdown()}
                  type={"contained"}
                  value={"Submit"}
                />
              )}

              <Button
                onClickHandler={() => cancelSession()}
                type={"only-text"}
                value={
                  ModalData.type === "collect" ? "Cancel" : "Got it, Thanks!"
                }
              />
            </div>
          ) : (
            feedbackContent()
          )}
        </ModalComponent>
      )}
      {/* <TransitionAlerts
        isAlert={alert}
        message={"Your documents uploded successfully!"}
      /> */}
      {loading && (
        <ModalComponent
          className={"loader-model"}
          show={loading}
          // handleClose={() => CancelData()}
          // title={ModalData.title}
          // content={ModalData.desc}
        >
          <GradientLoader />
        </ModalComponent>
      )}
    </div>
  );
}

export default SubmittedWelcome;
